
import { toast } from "sonner";
import { clearLocalStorage, clearSessionStorage, checkVersionAndReload } from "./localStorageUtils";
import { reloadStylesheets, refreshLoginPageStyles } from "./stylesheetUtils";
import { clearBrowserCaches } from "./serviceworkerUtils";
import { 
  forceFullRefresh, 
  pulseUIRefresh, 
  forceLayoutRecalculation, 
  clearAIReadinessReferences 
} from "./refreshUtils";

/**
 * Simple cache clearing without content/analysis caches
 */
export function clearCacheWithNotification(): void {
  try {
    // Clear localStorage items (except auth-related)
    clearLocalStorage();

    // Clear SessionStorage items
    clearSessionStorage();

    // Clear application cache if available
    clearBrowserCaches();

    // Force reload all stylesheets immediately
    reloadStylesheets();
    
    // Show success notification
    toast.success("Browser caches cleared successfully", {
      description: "Now performing a hard refresh to apply changes..."
    });

    // Automatically do a hard refresh after clearing cache
    setTimeout(() => forceFullRefresh(), 1500);
  } catch (error) {
    console.error("Error clearing cache:", error);
    toast.error("Failed to clear cache completely", {
      description: "Trying force refresh anyway..."
    });
    setTimeout(() => forceFullRefresh(), 1000);
  }
}

// Export all cache utilities
export {
  forceFullRefresh,
  pulseUIRefresh,
  forceLayoutRecalculation,
  refreshLoginPageStyles,
  checkVersionAndReload,
  clearLocalStorage,
  clearSessionStorage,
  clearBrowserCaches,
  reloadStylesheets,
  clearAIReadinessReferences
};
